import { createContext } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const ScreenResolutionContext = createContext();

const ScreenResolutionProvider = ({ children }) => {
  const theme = useTheme();
  const isCompactWidth = useMediaQuery(theme.breakpoints.down('sm')); // xs:  < 600
  const isMediumWidth = useMediaQuery(theme.breakpoints.between('sm', 'md')); // sm:  600–839
  const isExpandedWidth = useMediaQuery(theme.breakpoints.between('md', 'lg')); // md:  840–1199
  const isLargeWidth = useMediaQuery(theme.breakpoints.between('lg', 'xl')); // lg:  1200–1599
  const isExtraLargeWidth = useMediaQuery(theme.breakpoints.up('xl')); // xl+: ≥ 1600
  const isLandscape = useMediaQuery('(orientation: landscape) and (max-width: 1199.95px)');
  const canShowLandscapeContent = useMediaQuery(
    '(orientation: landscape) and (min-height: 580px) and (max-width: 1199.95px)',
  );

  return (
    <ScreenResolutionContext.Provider
      value={{
        isLandscape,
        canShowLandscapeContent,
        isCompactWidth,
        isMediumWidth,
        isExpandedWidth,
        isLargeWidth,
        isExtraLargeWidth,
      }}
    >
      {children}
    </ScreenResolutionContext.Provider>
  );
};

export { ScreenResolutionProvider, ScreenResolutionContext };
